/* ==========================================================================
   BatID · Cuenta atras de la barra superior
   Dos modos:
     - bucle: ciclo de N horas que se reinicia solo, para siempre.
     - fecha: hasta una fecha real; cuando pasa, la barra se esconde.
   Igual que el resto, lleva candado por si el archivo se carga dos veces.
   ========================================================================== */
(function () {
  'use strict';

  function dosCifras(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initContador(raiz) {
    (raiz || document).querySelectorAll('[data-bat-contador]').forEach(function (reloj) {
      if (reloj.dataset.batListo) return;
      reloj.dataset.batListo = '1';

      var modo = reloj.dataset.modo || 'bucle';
      var conDias = reloj.dataset.dias === 'true';

      var elD = reloj.querySelector('[data-bat-d]');
      var elH = reloj.querySelector('[data-bat-h]');
      var elM = reloj.querySelector('[data-bat-m]');
      var elS = reloj.querySelector('[data-bat-s]');

      // Cuanto dura un ciclo completo, en milisegundos
      var horas = parseFloat(reloj.dataset.horas);
      if (!horas || horas <= 0) horas = 48;
      var ciclo = horas * 3600 * 1000;

      // Fecha objetivo del modo "fecha real"
      var objetivo = null;
      if (modo === 'fecha') {
        var txt = (reloj.dataset.fecha || '').trim().replace(' ', 'T');
        var d = new Date(txt);
        if (!isNaN(d.getTime())) objetivo = d.getTime();
      }

      function restante() {
        var ahora = Date.now();
        if (modo === 'fecha') {
          if (!objetivo) return 0;
          return objetivo - ahora;
        }
        // Bucle: el mismo reloj para todo el mundo, sin guardar nada.
        // Al llegar a cero vuelve a empezar solo.
        return ciclo - (ahora % ciclo);
      }

      var barra = reloj.closest('.bat-barra');
      var timer = null;

      function pintar() {
        var ms = restante();

        if (ms <= 0) {
          // Solo pasa en modo fecha: la oferta termino de verdad
          if (barra) barra.hidden = true;
          if (timer) clearInterval(timer);
          return;
        }

        var s = Math.floor(ms / 1000);
        var dias = Math.floor(s / 86400);
        var hrs = Math.floor((s % 86400) / 3600);
        var min = Math.floor((s % 3600) / 60);
        var seg = s % 60;

        // Sin casilla de dias, las horas los absorben (48 h en vez de 2 d 00 h)
        if (!conDias || !elD) {
          hrs = Math.floor(s / 3600);
        } else {
          elD.textContent = dosCifras(dias);
        }

        if (elH) elH.textContent = dosCifras(hrs);
        if (elM) elM.textContent = dosCifras(min);
        if (elS) elS.textContent = dosCifras(seg);
      }

      pintar();
      timer = setInterval(pintar, 1000);

      // Al volver a la pestana, ponerlo en hora al instante
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) pintar();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initContador(document); });
  } else {
    initContador(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    initContador(ev.target);
  });
})();
